export default {
  BASIC: 'basic',
  CONTACTS: 'contacts',
};
